export default __webpack_public_path__ + "static/dsnchlz-c84c610231bd8e6a22e6b0a558885948.jpeg";